/*
 * @description: 
 * @author: Jason Wong
 * @since: 2023-03-30 14:19:12
 */
const TRACK_EDITOR_CLASS_NAME = "ve-editor";
const TRACK_EDITOR_EDITOR_ID_ATTRIBUTE_NAME = "data-ve-editor-id";
const TRACk_DISABLE_WHEN_IN_POSTIL = "无法修订，选中文本包含已有批注";
const EDIT_DISABLE_WHEN_IN_POSTIL_OR_TRACK = "请【接受/拒绝】修订或打开【跟踪修订】模式继续编辑。";

export {
    TRACK_EDITOR_CLASS_NAME,
    TRACK_EDITOR_EDITOR_ID_ATTRIBUTE_NAME,
    TRACk_DISABLE_WHEN_IN_POSTIL,
    EDIT_DISABLE_WHEN_IN_POSTIL_OR_TRACK,
};
